import { render, staticRenderFns } from "./DataSourceFormInput.vue?vue&type=template&id=0cf48e9a&"
import script from "./DataSourceFormInput.vue?vue&type=script&lang=ts&"
export * from "./DataSourceFormInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports